import { render } from "./FormAudience.vue?vue&type=template&id=026326c8"
import script from "./FormAudience.vue?vue&type=script&lang=js"
export * from "./FormAudience.vue?vue&type=script&lang=js"
script.render = render

export default script